

<template>
  <!-- https://michalsnik.github.io/aos/ -->
 <v-container>
    <v-card
      class="mx-auto"
      max-width="550"
      min-height="600"
    >

    <v-app-bar   v-if="!displayEndCard"  color="grey darken-1" dark dense>
      <v-spacer></v-spacer>

      <v-toolbar-title>End of Session</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>   

      <div style="position: relative;">

       <!--    END OF SESSION CONTENT   -->
       
        <div>            
          <v-card class="mx-auto" :style="{ maxWidth: '550px' }" d-flex flex-column justify-center align-center color="#E0E0E0"  min-height="600">
            <v-row  dense class="text-center">  
              <v-col  cols="12">
                <v-card-text  class="pa-0 pl-2 text-h6 grey--text text--darken-2">
                  Have a few  more minutes? Repeat!
                </v-card-text>
              </v-col>
            </v-row>
            <v-row  dense class="text-center">  
              <v-col  cols="12">
                <v-card-text  class="mt-0 pa-0 pl-2 grey--text text--darken-2">
                  You can skip exercises by hitting next (<v-icon  size="20" class="text-xs-center" color="rgba(169,169,169)">skip_next</v-icon>)
                </v-card-text>                  
              </v-col>
            </v-row>
              <v-row  dense class="text-center">  
                <v-col  cols="12">
                  <v-card-actions>
                    <v-spacer></v-spacer>   
                    <v-btn color="pink darken-2" outlined @click="repeat()">Repeat this session</v-btn>
                    <v-spacer></v-spacer>                  
                  </v-card-actions>         
                </v-col>
              </v-row>
              <v-row  dense class="text-center">  
                <v-col  cols="12">
                  <v-card-actions class="mt-6">
                    <v-spacer></v-spacer>
                      <v-btn color="pink darken-2" outlined @click="$router.push('/home')">Finish</v-btn>
                      <v-spacer></v-spacer>                  
                    </v-card-actions>
                </v-col>
              </v-row>
              <v-row  dense class="text-center">  
                <v-col  cols="12">
                  <div class="mt-8 pa-0 text-h5 text-center">Don't forget to hydrate <v-icon  size="35" class="text-xs-center" color="rgba(255,255,255)">mdi-cup-water</v-icon></div>
                </v-col>
              </v-row>
          </v-card>
        </div>
        <!-- ShareThis BEGIN --><div class="sharethis-inline-share-buttons"></div><!-- ShareThis END -->
      </div>
    </v-card>
  </v-container>
</template>


<script>


export default {

  data() {
    return {
    };
  },
  methods: {

    repeat() {
      console.log("REPEAT")
        this.$router.push({ path: 'session', query: { setID: this.$route.query.setID, time: Date.now() } })
      },
    handlePlay() {
      // Handle play event
    },
    handlePause() {
      // Handle pause event
    }
  }
};
</script>


